import React, { useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { CardAutocomplete } from 'components/Form';
import { IconWrapper } from 'components/Icon';

export const EntityFilter = ({ name, label, queryFunction, optionLabelName, ItemCard, value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(null);
  const selectedLabel = value?.[optionLabelName];

  const handleOpen = () => {
    setDraft(value);
    setOpen(true);
  };

  const handleClear = () => {
    onChange(null);
    setOpen(false);
  };

  const handleConfirm = () => {
    onChange(draft || null);
    setOpen(false);
  };

  return (
    <Box flexShrink={0}>
      <Button
        variant="outlined"
        onClick={handleOpen}
        sx={{
          backgroundColor: 'background.paper',
          borderRadius: 1,
          fontWeight: 400,
          lineHeight: '24px',
          fontFeatureSettings: '"liga" off, "cling" off',
          color: 'text.primary',
          borderColor: 'divider',
          whiteSpace: 'nowrap',
        }}
        endIcon={
          <IconWrapper
            icon="chevronDown"
            sx={{
              height: 14,
              width: 14,
              svg: {
                stroke: '#000',
                strokeWidth: 1,
                height: 14,
                width: 14,
                mt: -1.25,
              },
              ml: 1,
            }}
            height={14}
          />
        }
      >
        {label} {selectedLabel && `(${selectedLabel})`}
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>{label}</DialogTitle>
        <DialogContent>
          <CardAutocomplete
            name={name}
            label={`Select ${label}`}
            queryFunction={queryFunction}
            optionLabelName={optionLabelName}
            ItemCard={ItemCard}
            onChange={(newValue) => setDraft(newValue || null)}
            value={draft ? { ...draft, label: draft[optionLabelName] } : null}
            skipCreatingShadow={true}
            fetchOnOpen={true}
            fullWidth
            changeSelectedValueOnChange={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClear}>Clear</Button>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button onClick={handleConfirm} variant="contained">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
